import React from "react";
import { RevealOnScroll } from "../shared";
import { VERTICAL_READINESS } from "./verticalReadinessContent";

const NicheChip = ({ label }) => (
  <span className="inline-block font-mono text-[11px] sm:text-xs px-2.5 py-1 rounded-full border border-[#00D2FF]/30 text-partner-accent bg-[#00D2FF]/8">
    {label}
  </span>
);

const VerticalReadinessStrip = () => (
  <section
    className="relative border-y border-[#00D2FF]/15 bg-[#11151F]/60"
    data-testid="vertical-readiness-strip"
  >
    <div className="max-w-6xl mx-auto px-6 lg:px-8 py-8 sm:py-10">
      <RevealOnScroll>
        <span className="font-mono text-[10px] text-partner-muted tracking-[0.2em] mb-4 block">
          {VERTICAL_READINESS.tag}
        </span>
        <h2 className="text-xl sm:text-2xl md:text-3xl font-bold text-partner leading-snug mb-3 max-w-3xl">
          {VERTICAL_READINESS.headline}{" "}
          <span className="gradient-text">{VERTICAL_READINESS.headlineAccent}</span>
        </h2>
        <p className="text-sm sm:text-base text-partner-muted font-body max-w-2xl leading-relaxed mb-5">
          {VERTICAL_READINESS.subline}
        </p>
        <div className="flex flex-wrap items-center gap-2">
          {VERTICAL_READINESS.niches.map((niche) => (
            <NicheChip key={niche} label={niche} />
          ))}
          <span className="font-mono text-[11px] text-partner-muted">{VERTICAL_READINESS.nichesMore}</span>
        </div>
      </RevealOnScroll>
    </div>
  </section>
);

export default VerticalReadinessStrip;
